import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { ImageDuplicate, IWarningDetails } from '@core/entities/ImageWarning'

export class WarningDetails extends Entity<IWarningDetails> {
  @Type(() => ImageDuplicate)
  duplicates?: Array<ImageDuplicate>

  organisationId?: number

  id?: number

  public static new(payload: unknown): WarningDetails {
    const entity = plainToInstance(WarningDetails, payload)

    return entity
  }
}
